<template>
  <div class="mod-trade-pwd">
    <div class="content">
      <!-- 模块1：验证当前密码 -->
      <div v-show="step === 1" class="verify-pwd">
        <h2 class="title">{{ $t('m000001') }}</h2>
        <div class="pwd-input-wrap">
          <div class="tips">{{ $t('m000002') }}</div>
          <van-password-input
            :value="verifyForm.password"
            :gutter="10"
            :focused="showKeyboard"
            @focus="showKeyboard = true"
          />
          <van-number-keyboard
            v-model="verifyForm.password"
            :show="showKeyboard"
            @blur="showKeyboard = false"
            @input="onInput"
            maxlength="6"
          />
        </div>
        <div class="btn-wrap">
          <van-button block type="primary" class="submit-btn" :class="{ disabled: !isVerifyBtnEnabled }" @click="onVerifySubmit">{{ $t('m000035') }}</van-button>
        </div>
        <div class="forget-pwd" @click="$router.push('/app-pages/resetTradePwd')">{{ $t('m000003') }}</div>
      </div>

      <!-- 模块2：设置新密码 -->
      <div v-show="step === 2" class="set-password">
        <h2 class="title step-2">{{ $t('m000004') }}</h2>
        <van-form @submit="onResetSubmit">
          <van-field
            v-model="resetForm.password"
            :type="passwordVisible ? 'text' : 'password'"
            :placeholder="$t('m000005')"
            class="password-field"
            inputmode="numeric"
          >
            <template #right-icon>
              <template v-if="bgColor == 'black-theme'">
                <img src="@/assets/images/icon_eye_close-dark.png" class="eye" v-show="!passwordVisible" @click="togglePasswordVisibility('password')">
                <img src="@/assets/images/icon_eye_open-dark.png" class="eye" v-show="passwordVisible" @click="togglePasswordVisibility('password')">
              </template>
              <template v-else>
                <img src="@/assets/images/icon_eye_close.png" class="eye" v-show="!passwordVisible" @click="togglePasswordVisibility('password')">
                <img src="@/assets/images/icon_eye_open.png" class="eye" v-show="passwordVisible" @click="togglePasswordVisibility('password')">
              </template>
            </template>
          </van-field>
          <van-field
            v-model="resetForm.repeat_password"
            :type="confirmPasswordVisible ? 'text' : 'password'"
            :placeholder="$t('m000006')"
            class="password-field"
            inputmode="numeric"
          >
            <template #right-icon>
              <template v-if="bgColor == 'black-theme'">
                <img src="@/assets/images/icon_eye_close-dark.png" class="eye" v-show="!confirmPasswordVisible" @click="togglePasswordVisibility('repeat_password')">
                <img src="@/assets/images/icon_eye_open-dark.png" class="eye" v-show="confirmPasswordVisible" @click="togglePasswordVisibility('repeat_password')">
              </template>
              <template v-else>
                <img src="@/assets/images/icon_eye_close.png" class="eye" v-show="!confirmPasswordVisible" @click="togglePasswordVisibility('repeat_password')">
                <img src="@/assets/images/icon_eye_open.png" class="eye" v-show="confirmPasswordVisible" @click="togglePasswordVisibility('repeat_password')">
              </template>
            </template>
          </van-field>
          <div class="tips">
            <span class="text" :class="{ 'success': isPasswordLength }">
              <van-icon v-if="isPasswordLength" name="success" class="success-icon" />
              <span class="unit" v-else></span>
              {{ $t('m000007') }}
            </span>
            <span class="text" :class="{ 'success': isPasswordNumber }">
              <van-icon v-if="isPasswordNumber" name="success" class="success-icon" />
              <span class="unit" v-else></span>
              {{ $t('m000008') }}
            </span>
            <span class="text" :class="{ 'success': isPasswordMatch }">
              <van-icon v-if="isPasswordMatch" name="success" class="success-icon" />
              <span class="unit" v-else></span>
              {{ $t('m000009') }}
            </span>
          </div>
          <div class="btn-wrap">
            <van-button block type="primary" native-type="submit" class="submit-btn" :class="{ disabled: !isResetBtnEnabled }">{{ $t('m000035') }}</van-button>
          </div>
        </van-form>
        
      </div>
    </div>

    <div class="footer">
      <span class="text">{{ $t('m000010') }} </span>
      <span class="link" @click="contactService">{{ $t('m000011') }}</span>
    </div>
    <global-action-sheet v-model="showActionSheet" />
    <van-dialog v-model="showDialog" class="dialog" @confirm="onConfirm" @cancel="onCancel" :title="$t('m000013')" show-cancel-button :confirm-button-text="$t('m000036')" :cancel-button-text="$t('m000037')" >
      <div class="contain">
        {{ $t('m000012') }}
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { Toast, Form, Field, Button, PasswordInput, NumberKeyboard, Icon, Dialog } from 'vant'
import GlobalActionSheet from '@/components/GlobalActionSheet.vue'
import { closeWebView } from "@/utils/hybirdMethods";

export default {
  name: 'modTradePwd',
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [PasswordInput.name]: PasswordInput,
    [NumberKeyboard.name]: NumberKeyboard,
    [Icon.name]: Icon,
    GlobalActionSheet,
    [Dialog.Component.name]: Dialog.Component,

  },
  computed: {
    bgColor() {
      return this.$store.getters["common/bgColor"]
    },
    // 验证密码按钮状态
    isVerifyBtnEnabled() {
      return this.verifyForm.password.length === 6
    },
    // 重置密码按钮状态
    isResetBtnEnabled() {
      return this.isPasswordLength && this.isPasswordNumber && this.isPasswordMatch
    },
    isPasswordLength() {
      return this.resetForm.password.length === 6
    },
    isPasswordNumber() {
      return /^\d+$/.test(this.resetForm.password)
    },
    isPasswordMatch() {
      const { password, repeat_password } = this.resetForm
      return password && repeat_password && password === repeat_password
    }
  },
  data() {
    return {
      step: 1,
      showKeyboard: false,
      verifyForm: {
        password: ''
      },
      resetForm: {
        password: '',
        repeat_password: ''
      },
      passwordVisible: false,
      confirmPasswordVisible: false,
      showActionSheet: false,
      showDialog: false,
      verifyInfo: {},
      is_first_trade_pwd: 0
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      // 获取路由参数并转为数字，默认为0
      this.is_first_trade_pwd = Number(this.$route.query.is_first_trade_pwd) || 0
      // 如果是首次设置交易密码，直接展示模块2
      if (this.is_first_trade_pwd === 1) {
        this.step = 2
      }
    },
    onVerifySubmit() {
      const { password } = this.verifyForm
      if (!password) {
        Toast(this.$t('m000014'))
        return
      }
      if (password.length !== 6) {
        Toast(this.$t('m000015'))
        return
      }
      // 调用验证密码接口
      this.$apis.verifyTradePwd({ password, type: 2 }).then(res => {
        if (!res.msg) {
          this.verifyInfo = res
          this.step = 2
        }
      })
    },

    onResetSubmit() {
      const { password, repeat_password } = this.resetForm
      if (!password) {
        Toast(this.$t('m000014'))
        return
      }
      if (!repeat_password) {
        Toast(this.$t('m000016'))
        return
      }
      if (password !== repeat_password) {
        Toast(this.$t('m000017'))
        return
      }
      this.$apis.setTradePwd({ 
        ...this.resetForm, 
        sign: this.verifyInfo.sign,
        ...(this.is_first_trade_pwd === 1 ? { check_sign: 2 } : {})
      }).then(res => {
        if (!res.msg) {
          if (this.is_first_trade_pwd === 1) {
            this.showDialog = true
          } else {
            Toast(this.$t('m000032'))
            setTimeout(() => {
              this.onCancel()
            }, 1000)
          }
        }
      })
    },

    togglePasswordVisibility(field) {
      if (field === 'password') {
        this.passwordVisible = !this.passwordVisible
      } else if (field === 'repeat_password') {
        this.confirmPasswordVisible = !this.confirmPasswordVisible
      }
    },

    onInput(value) {
      this.verifyForm.password = value;
      if (value.length === 6) {
        this.showKeyboard = false;
      }
    },

    contactService() {
      this.showActionSheet = true
    },

    onConfirm() {
      this.$JsBridge.callHandler('jumpPage', {
        type: 2,
        url: 'SecurityCenter',
      })
      this.onCancel()
    },
    onCancel() {
      closeWebView()
    }
  }
}
</script>

<style lang="less" scoped>
.mod-trade-pwd {
  background: #fff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .content {
    flex: 1;
    padding: 40px 40px 0;
  }

  .title {
    // width: 554px;
    font-size: 34px;
    color: #0F0F2F;
    margin-bottom: 24px;
    font-weight: 500;
    &.step-2 {
      font-size: 52px;
    }
  }

  .pwd-input-wrap {
    .tips {
      font-size: 28px;
      color: #747377;
      margin-bottom: 20px;
    }
  }

  .forget-pwd {
    font-size: 28px;
    color: #328CF4;
    text-align: center;
    margin-top: 40px;
  }

  .btn-wrap {
    margin-top: 368px;
    display: flex;
    align-items: center;
    justify-content: center;

    .submit-btn {
      width: 568px;
      height: 104px;
      border-radius: 200px;
      background: #17161C;
      border: none;
      font-size: 32px;
      font-weight: 500;
      &.disabled {
        opacity: 0.5;
      }
    }
  }

  .tips {
    color: #0F0F2F;
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    .text {
      color: #747377;
      font-size: 28px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      &.success {
        color: #009a61;
      }

      .success-icon {
        color: #009a61;
        margin-right: 5px;
      }
      .unit {
        margin-right: 22px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #444;
      }
    }
  }

  .footer {
    padding: 30px 40px 60px;
    text-align: center;
    font-size: 28px;
    margin-top: auto;

    .text {
      color: #A2A2A2;
    }

    .link {
      color: #328CF4;
      text-decoration: underline;
    }
  }
}

::v-deep .van-field {
  height: 116px;
  background: transparent;
  padding: 0 !important;

  .van-field__body {
    input {
      color: #0F0F2F;
      font-size: 32px;
      font-weight: 500;
      &::placeholder {
        color: #B9B9B9;
      }
    }
  }
}

.password-field {
  ::v-deep .van-field__right-icon {
    height: 100%;
    display: flex;
    align-items: center;
    padding-right: 18px;

    .eye {
      width: 50px;
      height: 50px;
    }
  }
}

::v-deep .van-password-input {
  margin: 0 auto;
  .van-password-input__security {
    .van-password-input__item {
      background: #F6F6F6;
      border-radius: 8px;
      width: 88px;
      height: 120px;
    }
    &--focused {
      border-color: #328CF4;
    }
  }
}

.dialog{
  .contain {
    width: 488px;
    margin: 0 auto 40px;
    color: #747377;
    font-size: 32px;
  }
}

.black-theme {
  .mod-trade-pwd {
    background: #1B1C24;
    .title {
      color: white;
    }
    .tips {
      color: #9D9D9F;
    }
    .text {
      color: white;
    }
    .unit {
      background: white !important;
    }
    ::v-deep .dialog {
      background: #1b1c24;
      .van-dialog__header {
        color: white;
      }
      .contain {
        color: white;
      }
      .van-dialog__cancel {
        background: #d1d1d1;
      }
      .van-dialog__confirm {
        background: #377cfb;
      }
    }
    ::v-deep .van-field {
      .van-field__body {
        input {
          color: white;
          font-size: 32px;
          font-weight: 500;
          &::placeholder {
            color: #B9B9B9 !important;
          }
        }
      }
    }
    ::v-deep .van-password-input .van-password-input__security .van-password-input__item {
      background: #0a0b0f;
      i {
        background-color: white;
      }
      .van-password-input__cursor {
        background-color: white;
      }
    }
    ::v-deep .van-key__delete-icon {
      width: auto !important;
    }
    ::v-deep .van-number-keyboard {
      background: #1B1C24;
      .van-number-keyboard__body {
        .van-key__wrapper {
          .van-key {
            background: #0a0b0f;
            color: white;
          }
        }
      }
      
    }
  }
  
}

</style>